import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, DomainElement, State } from '../../../../library/Core/SmartTypes';
import { getinstituteList } from '../../../../library/Service/domainService';
import useManagementDashboard from '../../../management/dashboard/useManagementDashboard';
import Layout from './Layout';

// Internal admin sees 'New' (not 'Pending Action' — that label is institute-side only)
const INT_GRIEVANCE_STATUS_DOMAIN: DomainElement[] = [
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'new',          value: 'New',          parentCode: '', displayOrder: 1 },
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'underReview',  value: 'Under Review', parentCode: '', displayOrder: 2 },
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'acknowledged', value: 'Acknowledged', parentCode: '', displayOrder: 3 },
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'inprogress',   value: 'In Progress',  parentCode: '', displayOrder: 4 },
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'resolved',     value: 'Resolved',     parentCode: '', displayOrder: 5 },
    { categoryCode: 'INT_GRIEVANCE_STATUS', code: 'discarded',    value: 'Discarded',    parentCode: '', displayOrder: 6 },
];

const InternalAdminGrievanceReport = () => {
    const { globalState } = useContext(GlobalContext);
    const { getCampuses } = useManagementDashboard();

    // Populate institute dropdown — SUPER_ADMIN sees all published institutes via getCampuses()
    const campuses = getCampuses();
    const instituteList = getinstituteList('INSTITUTE_GROUP_CODE', campuses);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = new Map([...globalState.domain]);

        // Inject internal admin status domain (6 statuses, 'new' → 'New')
        domain.set('INT_GRIEVANCE_STATUS', INT_GRIEVANCE_STATUS_DOMAIN);

        // Populate institute dropdown for the filter panel
        if (instituteList.length > 0) {
            domain.set('INSTITUTE_GROUP_CODE', instituteList);
        }

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data,
                domain,
                internal,
                routeInfo,
            },
        });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {!state.flags.isDataLoading && <Layout />}
        </SmartContext.Provider>
    );
};

export default InternalAdminGrievanceReport;
